import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { testComponents, testServices } from './index';
import { SharedModule } from '../../shared/shared.module';
import { AccordionModule, } from 'primeng/accordion';
import { DragulaModule } from 'ng2-dragula';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../core/core.module';
import { UserModule } from '../../user/user.module';
import { CalendarModule } from 'primeng/calendar';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClickOutsideModule } from 'ng-click-outside';
import { DynamicFormModule } from '@ispm/dynamic-form/dynamic-form.module';
import { LayoutModule } from '../../layout/layout.module';
import { WorkflowConfigModule } from '@ispm/workflow/workflow-config.module';
import { TableModule } from 'primeng/table';
import { TestListItemComponent } from './components/test-actions/test-list/test-list-item/test-list-item.component';
import { DropdownWithTitleModule } from '../dropdown_with_title/dropdown-with-title.module';
import { ImmunotherapyComponent } from './components/immunotherapy/immunotherapy.component';
import { ChartsModule as Ng2Charts } from 'ng2-charts';
import { AberrationExtraDetailsComponent } from './components/aberration-extra-details/aberration-extra-details.component';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { AberrationNotesTabComponent } from './components/aberration-notes-tab/aberration-notes-tab.component';
import { NotesModule } from '../../notes/notes.module';
import { AberrationInfoTabComponent } from './components/aberration-info-tab/aberration-info-tab.component';
import { DataTableComponent } from './components/data-table/data-table.component';
import { KeyValueCardComponent } from './components/key-value-card/key-value-card.component';
import { AberrationInfoTabContentComponent } from './components/aberration-info-tab/aberration-info-tab-content/aberration-info-tab-content.component';
import { CurationTherapyMatchComponent } from './components/curation-therapy-match/curation-therapy-match.component';
import { QualityCheckModule } from '../../quality-check/quality-check.module';
import { ProfileV2Component } from './components/profileV2/profileV2.component';
import { DataCollectionTabComponent } from './components/data-collection-tab/data-collection-tab.component';
import { DocumentsTabComponent } from './components/documents-tab/documents-tab.component';
import { CollectionFormComponent } from './components/collection-form/collection-form.component';
import { ConfigurationModule } from '../../configuration/configuration.module';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { EffectsModule } from '@ngrx/effects';
import { TestBarEffects } from '@ispm/test/store/test-bar.effects';
import { SpecimensAndSamplesModule } from '../../specimens-and-samples/specimens-and-samples.module';
import { UserActionCreatorService } from '@ispm/user/services/user-action-creator.service';
import { UserService } from '@ispm/user/services/user.service';
import { PatientBarComponent } from '@ispm/test/components/patient-bar/patient-bar.component';
import { LayoutEngineModule } from '@ispm-client/modules/layout-engine';
import { PrefetchDataEffects } from '@ispm/test/store/prefetch-data/prefetch-data.effects';
import { DashboardMenuModule } from '@ispm/dashboard/menu/menu.module';
import { ObjectWalkService } from '@ispm/shared/services/object-walk.service';
import { CurationNavigationVerticalContainerComponent } from './components/curation-navigation-vertical-container/curation-navigation-vertical-container.component';
import { VerticalTestActionsContainerComponent } from './components/vertical-test-actions/vertical-test-actions-container/vertical-test-actions-container.component';
import { VerticalTestActionsListComponent } from './components/vertical-test-actions/vertical-test-actions-list/vertical-test-actions-list.component';
import { VerticalTestActionsItemComponent } from './components/vertical-test-actions/vertical-test-actions-item/vertical-test-actions-item.component';
import { CurationNavigationPathwayExecutionComponent } from './components/curation-navigation-pathway-execution/curation-navigation-pathway-execution.component';
import { HeaderInfoComponent } from './components/header-info/header-info.component';
import { PathwayActionsComponent } from './components/pathway-actions/pathway-actions.component';
import { CurationWorkflowStepperComponent } from './components/curation-workflow-stepper/curation-workflow-stepper.component';
import { PathwaysModule } from '@ispm-client/modules/pathways';
import { WidgetsModule } from '@ispm-client/modules/widgets';
import { PathwayStepsListComponent } from './components/pathway-steps-list/pathway-steps-list.component';
import { PathwayTreatmentsListComponent } from './components/pathway-treatments-list/pathway-treatments-list.component';
import { PathwayDocumentsListComponent } from './components/pathway-document-list/pathway-documents-list.component';
import { AgregationService } from '@ispm-client/modules/aggregator/services';
import { CheckboxModule } from 'primeng/checkbox';
import { MenuModule } from 'primeng/menu';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { SharedModule as PNGSharedModule } from 'primeng/api';
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { RadioButtonModule } from "primeng/radiobutton";
import { ToggleSwitchModule } from '@wuitk/angular/components/toggleswitch';
import { WorkflowService } from '@ispm/workflow/services/workflow.service';
import { FilterModule } from '../../filter/filter.module';
import { DlsSharedModule } from '../../dls-shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { ExportModule } from '../../export/export.module';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { RouterModule } from "@angular/router";
import { AberrationsComponent } from "@ispm/migration/components/aberrations/aberrations.component";
import {
  AberrationColumnComponent
} from "@ispm/migration/components/aberrations/aberration-column/aberration-column.component";
import {
  AberrationExtraModalComponent
} from "@ispm/migration/components/aberrations/aberration-extra-modal/aberration-extra-modal.component";
import { TestTabComponent } from '@ispm/test/components/test-tab/test-tab.component';
import { TestHeaderElementsComponent } from "@ispm/test/components/test-header-elements/test-header-elements.component";
import { TestInfoComponent } from "@ispm/test/components/test-info/test-info.component";
import { TestActionsComponent } from "@ispm/test/components/test-actions/test-actions.component";
import { TestCustomTabComponent } from '@ispm/test/components/test-custom-tab/test-custom-tab.component';
import { PaginatorModule } from 'primeng/paginator';
import { NotesService } from '@ispm/user/services/notes.service';
import { EditManagingFacilityComponent } from '@ispm/test/components/edit-managing-facility/edit-managing-facility.component';
import {
  ReleaseInterpretationComponent
} from "@ispm/migration/components/aberrations/release-interpretation/release-interpretation.component";
import { EditorModule } from 'primeng/editor';
@NgModule({
  imports: [
    DlsSharedModule,
    PathwaysModule,
    BrowserAnimationsModule,
    CommonModule,
    CoreModule,
    SharedModule,
    DynamicFormModule,
    UserModule,
    CheckboxModule,
    DragulaModule,
    CalendarModule,
    AutoCompleteModule,
    AccordionModule,
    FormsModule,
    BrowserModule,
    MenuModule,
    PNGSharedModule,
    LayoutModule,
    NotesModule,
    ScrollToModule.forRoot(),
    ClickOutsideModule,
    ReactiveFormsModule,
    WorkflowConfigModule,
    TieredMenuModule,
    TableModule,
    DropdownWithTitleModule,
    Ng2Charts,
    CheckboxModule,
    QualityCheckModule,
    LayoutEngineModule,
    DashboardMenuModule,
    ProgressSpinnerModule,
    RadioButtonModule,
    FilterModule,
    NgxDropzoneModule,
    RouterModule.forRoot([]),
    ConfigurationModule,
    PdfJsViewerModule,
    SpecimensAndSamplesModule,
    EffectsModule.forFeature([TestBarEffects, PrefetchDataEffects]),
    WidgetsModule,
    ToggleSwitchModule,
    ExportModule,
    PaginatorModule,
    EditorModule
  ],
  declarations: [...testComponents, TestListItemComponent, AberrationExtraDetailsComponent,
    AberrationNotesTabComponent, AberrationInfoTabComponent, DataTableComponent, KeyValueCardComponent,
    AberrationInfoTabContentComponent, CurationTherapyMatchComponent, ProfileV2Component,
    DataCollectionTabComponent, DocumentsTabComponent, CollectionFormComponent,
    PatientBarComponent, CurationNavigationVerticalContainerComponent, CurationNavigationPathwayExecutionComponent, HeaderInfoComponent,
    PathwayActionsComponent, CurationWorkflowStepperComponent, PathwayStepsListComponent, PathwayTreatmentsListComponent,
    PatientBarComponent, CurationNavigationVerticalContainerComponent, CurationNavigationPathwayExecutionComponent,
    HeaderInfoComponent, PathwayActionsComponent, CurationWorkflowStepperComponent, PathwayStepsListComponent,
    PathwayTreatmentsListComponent, VerticalTestActionsContainerComponent, VerticalTestActionsListComponent,
    VerticalTestActionsItemComponent, CurationWorkflowStepperComponent, PathwayStepsListComponent, PathwayTreatmentsListComponent,
    PathwayDocumentsListComponent, AberrationsComponent, AberrationColumnComponent, AberrationExtraModalComponent,
    TestTabComponent, TestCustomTabComponent, EditManagingFacilityComponent, ReleaseInterpretationComponent
  ],
  providers: [...testServices,WorkflowService, UserActionCreatorService, UserService, ObjectWalkService, AgregationService, NotesService
  ],
  exports: [ImmunotherapyComponent, TestHeaderElementsComponent, PatientBarComponent, TestInfoComponent, TestActionsComponent], // todo:exports Immunotherapy & molecular findings to MolecularFindingsModule
})
export class TestModule {
}
